export default __webpack_public_path__ + "static/media/IMG8.231898af.png";